import styled from 'styled-components';

export const LegendWrapper = styled.div`
  position: absolute;
  z-index: 5;
  top: 90px;
  right: 30px;
  width: 300px;
  align-items: flex-end;
  justify-content: flex-end;
  border-radius: 16px;
  transition: all 0.2s ease-in-out;
`;

export const Panel = styled.div`
  top: 0;
  left: 0;
  width: 300px;
  z-index: 20;
  // padding: 20px;
  background: #fff;
  position: absolute;
  border-radius: 16px;
`;
